module.exports = __webpack_public_path__ + "img/sucess-mark.54f62595.png";